export const TYPEFACES_FILTERING_CATEGORIES = [
  { id: 'name:asc', name: 'Name A-Z', value: { field: 'NAME', direction: 'ASC' } },
  { id: 'name:desc', name: 'Name Z-A', value: { field: 'NAME', direction: 'DESC' } },
  {
    id: 'first_published_at:desc',
    name: 'Latest (Descending)',
    customContent: (
      <>
        <div style={{ textAlign: 'left', flexGrow: 1 }}>
          Latest <span className="charcoal">(Descending)</span>
        </div>
      </>
    ),
    value: { field: 'PUBLISHED_AT', direction: 'DESC' }
  },
  {
    id: 'content.popularity:desc',
    name: 'Most Popular',
    value: { field: 'RATING', direction: 'DESC' }
  },
  { id: 'content.hiddenGem', name: 'Hidden Gems', value: { field: 'RATING', direction: 'ASC' } }
];
